import React from 'react'
import ReactDOM from 'react-dom'

import App from './App'
import 'config/sentry'

if (process.env.REACT_APP_MOCK === 'TRUE') {
  void (async () => {
    const { worker } = await import('./mocks/browser')

    await worker.start()

    ReactDOM.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
      document.getElementById('root'),
    )

    worker.printHandlers()
  })()
} else {
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById('root'),
  )
}
